import { Height } from "@mui/icons-material";

const locale = {
  APPLICATIONS: "Murojaatlar",
  TheRegistry: "Yozuv roʻyxati",
  ThePatients: "Mijozlar",
  WaitingList: "Navbatdagi mijozlar",
  Telephony: "Qo‘ng‘iroqlar",
  Doctors: "Xodimlar",
  WorkingHours: "Ish vaqtlari",
  Access: "Kirish",
  Testimonials: "Sharhlar",
  Services: "Xizmatlar",
  Resources: "Resurslar",
  EmailSMS: "Elektron pochta va SMS",
  AutoNotifications: "Avtomatik xabarnomalar",
  MailOut: "Pochtaga yuborish",
  Balance: "Balans",
  MessageHistory: "Xabarlar tarixi",
  Analytics: "Ma’lumotlar tahlili",
  GeneralAnalytics: "Umumiy tahlil",
  Employees: "Xodimlar",
  Employee: "Xodim",
  BlackBox: "Qora quti",
  MaterialAccounting: "Materiallar hisobi",
  Products: "Mahsulotlar",
  OrderProducts: "Buyurtmali mahsulotlar",
  Categories: "Kategoriyalar",
  Brands: "Brendlar",
  Suppliers: "Taʼminotchi",
  FlowOfGoods: "Mahsulotlar oqimi",
  Storages: "Omborlar",
  Inventory: "Inventarizatsiya",
  Payroll: "Maoshlar hisobi",
  SalarySettings: "Maosh sozlamalari",
  OnlineBooking: "Onlayn bandlik",
  CompanysSettings: "Kompaniya sozlamalari",
  Payment: "Toʻlov",
  SignIn: "Kirish",
  SignedOut: "Chiqish",
  UserName: "Foydalanuvchi nomi",
  Password: "Parol",
  SignOut: "Chiqish",
  Branch: "Filial",
  Company: "Kompaniya",
  Save: "Saqlash",
  AboutCompany: "Kompaniya haqida",
  TheTitleOfTheCompany: "Kompaniya nomi",
  BankingDetails: "Bank maʼlumotlari",
  EnterTheBankingDetails: "Bank maʼlumotlarini kiriting",
  TheNameOfTheCompany: "Kompaniya nomi",
  Activity: "Faoliyat turi",
  PhoneNumberOwners: "Telefon raqami",
  TheCompanysAddress: "Kompaniya manzili",
  City: "Shahar",
  SessionHistoryRetentionPeriod: "Murojaat tarixini saqlash davri",
  SettingsAreSaved: "Sozlamalar saqlandi",
  PhoneNumber: "Mobil telefon",
  EmailAddress: "Elektron pochta manzili",
  CategoryPermission: "Ruxsat turi",
  Function: "Amallar",
  Jurnal: "Jurnal",
  Online: "Onlayn",
  NewAdministrator: "Yangi administrator",
  NewDoctor: "Yangi doktor",
  SettingsProfile: "Sozlamalar profili",
  Name: "Ism",
  Surname: "Familiya",
  EmailProgramAccess: "Elektron pochta (Dasturga kirish)",
  Dostup: "Kirish",
  AvailableTimeForOnlineRegistration: "Onlayn ro‘yxat uchun vaqtlar",
  Phone: "Telefon",
  Access: "Kirish",
  Photo: "Rasmlar",
  BeginningOfWork: "Ish boshlanishi",
  January: "Yanvar",
  February: "Fevral",
  March: "Mart",
  April: "Aprel",
  May: "May",
  June: "Iyun",
  July: "Iyul",
  August: "Avgust",
  September: "Sentabr",
  October: "Oktabr",
  November: "Noyabr",
  December: "Dekabr",
  Monday: "Dushanba",
  Tuesday: "Seshanba",
  Wednesday: "Chorshanba",
  Thursday: "Payshanba",
  Friday: "Juma",
  Saturday: "Shanba",
  Sunday: "Yakshanba",
  Mon: "Du",
  Tue: "Se",
  Wed: "Cho",
  Thur: "Pa",
  Fri: "Ju",
  Sat: "Sha",
  Sun: "Ya",
  TODAY: "Bugun",
  Description: "Tavsif",
  Patients: "Mijozlar",
  Birthday: "Tugʻilgan kun",
  Gender: "Jins",
  Discount: "Chegirma",
  EntriesInmonths53: "3 oyda 5+ yozuv",
  EntriesInmonths23: "3 oyda 2+ yozuv",
  HaventRegis3: "3 oydan beri ro‘yxatdan o‘tmagan",
  HaventRegis6: "6 oydan beri ro‘yxatdan o‘tmagan",
  NotReg: "Roʻyxatdan oʻtmagan",
  InTheLast30days: "So‘nggi 30 kun ichida",
  CantSignUpOnline: "Onlayn ro‘yxatdan o‘tish mumkin emas",
  CanceledCO: "Bekor qilingan tashriflar % bajarilganlaridan ko‘p",
  Filtr: "Saralash",
  MostActive: "Eng faol mijozlar",
  Permanent: "Doimiy mijozlar",
  NotActive: "Faol bo‘lmagan",
  Missing: "Yo‘qotilganlar",
  DidntVisit: "Tashrif buyurmagan",
  NewClients: "Yangi mijozlar",
  BlackList: "Qora roʻyxat",
  Problematic: "Muammoli",
  AllInformation: "Barcha maʼlumotlar",
  CardNumbers: "Karta raqamlari",
  SurnameD: "Sharif",
  FamilyCard: "Oilaviy karta",
  Boy: "Erkak",
  Girl: "Ayol",
  GenderSelect: "Jinsni tanlang",
  Pasport: "Pasport",
  TheNote: "Eslatma",
  LegalRepesentative: "Qonuniy vakil",
  SocialNetwork: "Ijtimoiy tarmoq",
  Address: "Manzil",
  LoyaltyPrograms: "Mijozlarga kengaytirilgan dasturlar",
  Insurance: "Sugʻurta",
  Newsletters: "Yangiliklar",
  AutoNote: "Avtomatik eslatma",
  NewClient: "Yangi mijoz",
  Country: "Mamlakat",
  Region: "Viloyat",
  PersonalDiscount: "Shaxsiy chegirma",
  InsuranceCompany: "Sugʻurta kompaniyasi",
  NumberPolice: "Polis raqami",
  NewPatient: "Yangi mijoz",
  English: "Ingilizcha",
  Russian: "Ruscha",
  Uzbek: "Oʻzbek",
  UzbekKril: "Oʻzbek - Kril",
  SelectABranch: "Filial tanlang",
  SearchClientServicesCreatingVisit: "Mijoz, xizmatlarni qidiring, tashrifni yarating",
  Partner: "Hamkor",
  AvailableTimeForOnlineRegistration: "Onlayn roʻyxatga olish uchun mavjud vaqt",
  Specialization: "Mutaxassislik",
  Short: "Oddiy",
  Average: "O‘rtacha",
  Admin: "Ma'mur",
  DeleteEmploye: "Ishchi oʻchirilsinmi?",
  Delete: "Oʻchirish",
  Cancel: "Qaytish",
  SuccessfulSaved: "Muvaffaqiyatli saqlandi",
  NameN: "Nomi",
  NameProduct: "Tovar nomi",
  CodeProduct: "Tovar kodi",
  NominalVolume: "Nominal hajmi",
  Remainder: "Qolgan qismi",
  Reserve: "Rezerv",
  Unit: "Oʻlchov birligi",
  LowBalanceNotification: "Past qolgan miqdor ogohlantirish",
  EnableWarehouseControl: "Ombor nazoratini yoqish",
  EnableRetailSales: "Qilgan sotishni yoqish",
  Brend: "Brend",
  Brands: "Brendlar",
  Category: "Kategoriya",
  NameCategory: "Kategoriya nomi",
  NewCategory: "Yangi kategoriya",
  EditCategory: "Kategoriyani tahrirlash",
  DeleteCategory: "Kategoriyani oʻchirish?",
  SearchCategories: "Kategoriyalarni qidirish",
  Seria: "Seriya",
  Serias: "Seriyalar",
  NameSeria: "Seriya nomi",
  NewSeria: "Yangi seriya",
  EditSeria: "Seriyani tahrirlash",
  DeleteSeria: "Seriyani oʻchirish?",
  SearchSerias: "Seriyalarni qidirish",
  NameBrands: "Brend nomi",
  NewBrands: "Yangi brend",
  EditBrands: "Brendni tahrirlash",
  DeleteBrands: "Brendni oʻchirish?",
  SearchBrands: "Brendlarni qidirish",
  NameResources: "Resurs nomi",
  NewResources: "Yangi resurs",
  EditResources: "Resursni tahrirlash",
  DeleteResources: "Resursni oʻchirish?",
  SearchResources: "Resurslarni qidirish",
  NewProduct: "Yangi tovar",
  Invoice: "Hisob-faktura",
  EditProduct: "Mahsulotni tahrirlash",
  DeleteProduct: "Mahsulotni oʻchirish?",
  SearchProduct: "Mahsulotlarni qidirish",
  NameSuppliers: "Yetkazib beruvchi",
  Suppliers: "Yetkazib beruvchilar",
  NewSuppliers: "Yangi yetkazib beruvchi",
  EditSuppliers: "Yetkazib beruvchini tahrirlash",
  DeleteSuppliers: "Yetkazib beruvchini o'chirasizmi?",
  SearchSuppliers: "Yetkazib beruvchini qidirish",
  WebSite: "Veb-sayt",
  NameStoreHouses: "Ombor nomi",
  NewStoreHouses: "Yangi ombor",
  EditStoreHouses: "Omborni tahrirlash",
  DeleteStoreHouses: "Omborni oʻchirasizmi?",
  SearchStoreHouses: "Omborlarni qidirish",
  RetailPrice: "Doʻkon narxi",
  SupplierPrice: "Yetkazib beruvchi narxi",
  DownloadXLS: "XLS-ni yuklash",
  All: "Hammasi",
  From: "Sanadan:",
  To: "Sanagacha:",
  Operation: "Amal",
  WorkingDays: "Ish kunlari:",
  WorkingHours: "Ish soatlari",
  HoursForServices: "Xizmat soatlari:",
  ServicesCarriedOut: "Bajarilgan xizmatlar:",
  AmountOfServices: "Xizmatlar summasi:",
  ProductsSold: "Sotilgan tovarlar:",
  AmountOfGoods: "Tovar summasi:",
  EmployeeIncome: "Xodim daromadi:",
  CompanyRevenue: "Korxona daromadi:",
  StartTime: "Boshlanish vaqti",
  ServiceTime: "Xizmat vaqti",
  Service: "Xizmat",
  OfTheService: "Xizmatning %",
  Product: "Tovar",
  OfTheProduct: "Tovarning %",
  IncomeEmployees: "Xodimlar daromadi",
  CompanyRevenue: "Korxona daromadi",
  ServicesProvided: "Ko‘rsatilgan xizmatlar:",
  ItemsSold: "Sotilgan mahsulotlar:",
  SalarySettings: "Maosh sozlamalari",
  SelectingABet: "Stavkani tanlash",
  MonthlySalary: "Oylik ish haqi",
  GuaranteedSalary: "Kafolatlangan maosh",
  PercentageOnSales: "Sotuvlar bo‘yicha foizlar",
  Rates: "Stavkalar",
  Hours: "Soatlar",
  EnterCategoryName: "Kategoriya nomini kiriting",
  ES1: "SMS ogohlantirishlar",
  ES2: "(Ogohlantirishlar o‘chirilgan. Yetarli balans yo‘q)",
  ES3: "Avtomatik ogohlantirishlar (ro‘yxatdan o‘tish, tashrif eslatmalari, ro‘yxatdan o‘chirish)",
  ES4: "Ro‘yxatdan o‘tishda ogohlantirish",
  ES5: "Tashrif haqida eslatma",
  ES6: "Tashrif eslatmalari intervali",
  ES7: "Kun oldin yuborilgan:",
  ES8: "SMS va email balans pastligi haqida ogohlantirish",
  ES9: "Mijozlarni vaqtida ro‘yxatdan o‘tkazish zarur, chunki SMS eslatmalari tez-tez yuboriladi",
  ES10: "Email ogohlantirishlar",
  ES11: "Avtomatik ogohlantirishlar (ro‘yxatdan o‘tish, tashrif eslatmalari)",
  ES12: "Tashrifni o‘chirish ogohlantirishlari",
  ES13: "Tashrif eslatmalari",
  ES14: "SMSdagi tashrif havolasi",
  ES15: "SMSdagi xizmat nomi",
  ES16: "Yangi mijozlarni tasdiqlash",
  ES17: "SMS avto izohnoma",
  ES18: "Email avtomatik xabarnoma",
  before: "Oldin",
  TurnOff: "O‘chirish",
  EL1: "SMS tarqatish",
  EL2: "SMS soni:",
  EL3: "Belgilar soni:",
  EL4: "Matn kiriting",
  EL5: "Qabul qiluvchini tanlash",
  EL6: "Barcha mijozlar",
  EL7: "Barcha xodimlar",
  EL8: "Tarqatish yaratish",
  EB1: "SMS soni:",
  EB2: "Email soni:",
  EB3: "Balansni toʻldirish",
  EH1: "Telefon raqamiga",
  Text: "Matn",
  EH2: "SMS soni",
  EHNO: "Resurslar - bu mahsulotlarni ko‘rsatishda ishlatiladigan vositalar. Ularni bir vaqtning o‘zida bir necha xodim ishlatolmaydi. Resursni yaratib, kerakli xizmatlarda faollashtiring.",
  Resources: "Resurslar",
  Date: "Sana",
  NewServices: "Yangi xizmatlar",
  DeleteGroups: "Xizmat guruhini o‘chirishmi?",
  DeleteGroupsInfo: "Bu harakat guruhdagi tashriflarning o‘chirilishiga olib kelishi mumkin. Tashriflarni tekshiring va saqlang.",
  NewEntry: "Yangi yozuv",
  Entry: "Yozuv",
  min: "daqiqa",
  Beginning: "Boshlangʻich",
  Duration: "Davomiyligi",
  OneTimeDiscount: "Bir martalik chegirma",
  Executor: "Bajaruvchi",
  ActualPrice: "Haqiqiy narx",
  AddAService: "Xizmat qo‘shish",
  AddHelpers: "Yordamchi qo‘shish",
  AddingAPatient: "Mijoz qo‘shish",
  Telefon: "Telefon",
  AllAmount: "Umumiy narx",
  Day: "Kun",
  Month: "Oy",
  Year: "Yil",
  Profile: "Profil",
  VisitHistory: "Tashrif tarixi",
  MedCard: "Tibbiyot kartasi",
  VisitAmount: "Tashriflar soni",
  MiddleCheck: "O‘rtacha chek",
  Canceled: "Bekor qilingan",
  Done: "Bajarildi",
  VisitAll: "Jami tashriflar",
  Price: "Narx",
  MinimalBudget: "Minimal byudjet",
  FinanceAnal: "Moliyaviy tahlil",
  TotalRecords: "Jami yozuvlar",
  OnlineRecords: "Onlayn yozuvlar",
  JurnalRecords: "Jurnal yozuvlar",
  SinceYes: "kundan boshlab",
  NewPatients: "Yangi mijozlar",
  RegularPatients: "Doimiy mijozlar",
  NoPatients: "Mijoz yoʻq",
  PatientsNotCome: "Kelmagan mijozlar",
  NotCatgoryService: "Agar kategoriyada xizmatlar boʻlsa, uni oʻchirmaslik kerak.",
  NameService: "Xizmat nomi",
  DetailsServices: "Xizmat tafsilotlari",
  SettingsService: "Xizmat sozlamalari",
  LocalCurrency: "Valyuta",
  Amountto: "dan",
  AmountFrom: "gacha",
  AmountService: "Xizmat narxi",
  Details: "Tafsilotlar",
  EditServices: "Xizmatni tahrirlash",
  DeleteServices: "Xizmatni oʻchirish?",
  SearchServices: "Xizmat nomini kiriting",
  Owner: "Egasi",
  LichCalendar: "Shaxsiy taqvim",
  Shop: "Doʻkon",
  stock: "Ombor",
  AddSales: "Yangi sotuv",
  HAddSR: "Mahsulot importi",
  Buyer: "Xaridor",
  Back: "Orqaga",
  Code: "Kod",
  Status: "Holat",
  OrderPrice: "Buyurtma narxi",
  Instalment: "Olasilik",
  NameSubcategory: "Kategoriya",
  NewSubcategory: "Yangi quyi kategoriya",
  EditSubcategory: "Quyi kategoriyani tahrirlash",
  DeleteSubcategory: "Quyi kategoriyani oʻchirish?",
  SearchSubcategories: "Quyi kategoriyalarni qidirish",
  Subcategories: "Quyi kategoriyalar",
  Subcategory: "Quyi kategoriya",
  Quantity: "Miqdor",
  Add: "Qoʻshish",
  Repair: "Taʼmir",
  Order: "Buyurtma",
  Nomenclature: "Nomenklatura",
  Purchase: "Import",
  Sales: "Sotuv",
  InterBranch: "Filiallar oʻrtasida",
  NothingAdded: "Hech narsa qoʻshilmagan",
  EditEntry: "Yozuvni tahrirlash",
  ClientWaiting: "Mijoz kutilmoqda",
  ClientCome: "Mijoz keldi",
  ClientNo: "Mijoz kelmadi",
  ClientSuccess: "Mijoz tasdiqlandi",
  Master: "Mutaxassis",
  Edit: "Tahrirlash",
  DeleteEntry: "Yozuvni o'chirish",
  Directorys: "Qo'llanmalar",
  Directory: "Katalog",
  NameDirectorys: "Katalog nomi",
  NewDirectorys: "Yangi katalog",
  EditDirectorys: "Katalogni tahrirlash",
  DeleteDirectorys: "Katalogni o'chirish?",
  SearchDirectorys: "Kataloglarni qidirish",
  MatrialTypes: "Matrial turlari",
  MatrialType: "Matrial turi",
  NameMatrialTypes: "Matrial turi nomi",
  NewMatrialTypes: "Yangi matrial turi",
  EditMatrialTypes: "Matrial turini tahrirlash",
  DeleteMatrialTypes: "Matrial turini o'chirish?",
  SearchMatrialTypes: "Matrial turlarni qidirish",
  ExecutorType: "Ijro turi",
  NameExecutorTypes: "Ijro turi nomi",
  NewExecutorTypes: "Yangi ijro turi",
  EditExecutorTypes: "Ijro turini tahrirlash",
  DeleteExecutorTypes: "Ijro turini o'chirish?",
  SearchExecutorTypes: "Ijro turlarni qidirish",
  ColourType: "Rang",
  NameColourTypes: "Rang nomi",
  NewColourTypes: "Yangi rang",
  EditColourTypes: "Rang tahrirlash",
  DeleteColourTypes: "Rang o'chirish?",
  SearchColourTypes: "Ranglarni qidirish",
  VentilationSize: "Ventilyatsiya hajmi",
  NameVentilationSizes: "Ventilyatsiya hajmi nomi",
  NewVentilationSizes: "Yangi ventilyatsiya hajmi",
  EditVentilationSizes: "Ventilyatsiya hajmini tahrirlash",
  DeleteVentilationSizes: "Ventilyatsiya hajmini o'chirish?",
  SearchVentilationSizes: "Ventilyatsiya hajmlarini qidirish",
  Client: "Mijoz",
  Report: "Hisobot",
  DebitOrderTransact: "Buyurtma tranzaksiyalari",
  DebitTotalTransact: "Jami sotuvlar",
  DebitTransactSummary: "Mahsulot hisoboti",
  ClientName: "Mijoz ismi",
  Fullname: "FIO",
  VentilationType: "O'lchov birliklari",
  Measure: "O'lchov",
  AutoSalary: "Avtomatik maoshlar",
  ProductsNo: "Tovar yo'q",
  ProductsAdd: "Tovar qo'shish",
  ListProducts: "Mahsulotlar ro'yxati",
  Amount: "Summa",
  ProductsAmount: "Xizmat narxi",
  Waiting: "Kutilmoqda",
  RowsPerPage: "Sahifadagi qatorlar",
  Consumptions: "Chiqimlar",
  Consumption: "Chiqim",
  NameConsumptions: "Chiqim nomi",
  NewConsumptions: "Yangi chiqim",
  EditConsumptions: "Chiqimni tahrirlash",
  DeleteConsumptions: "Chiqimni o'chirish?",
  SearchConsumptions: "Chiqimlarni qidirish",
  Success: "Muvaffaqiyatli",
  Expectations: "Kutilmoqda",
  Vendor: "Sotuvchi",
  RateAmount: "Chegirma narxi",
  Date: "Vaqt",
  Reset: "Tozalash",
  OptionType: "Variant",
  NameOptionTypes: "Variant nomi",
  NewOptionTypes: "Yangi variant",
  EditOptionTypes: "Variantni tahrirlash",
  DeleteOptionTypes: "Variantni o'chirish?",
  SearchOptionTypes: "Variantlarni qidirish",
  TypeType: "Tur",
  NameTypeTypes: "Tur nomi",
  NewTypeTypes: "Yangi tur",
  EditTypeTypes: "Turni tahrirlash",
  DeleteTypeTypes: "Turni o'chirish?",
  SearchTypeTypes: "Turlarni qidirish",
  SerialType: "Seriya turi",
  NameSerialTypes: "Seriya turi nomi",
  NewSerialTypes: "Yangi seriya turi",
  EditSerialTypes: "Seriya turini tahrirlash",
  DeleteSerialTypes: "Seriya turini o'chirish?",
  SearchSerialTypes: "Seriya turlarni qidirish",
  Request: "So'rovlar",
  AddRequest: "So'rov qo'shish",
  EnterProductName: "Mahsulot nomini kiriting",
  NotMandatory: "(Tanlash majburiy emas!)",
  Settings: "Sozlamalar",
  Today: "Bugun",
  Previous: "Oldingi",
  Next: "Keyingi",
  Wait: "Tasdiqlanmagan",
  Paid: "To'langan",
  Finance: "Moliya",
  CASH: "Naqd",
  UZCARD: "Uzcard",
  HUMO: "Humo",
  TRANSFER: "Perechisleniya",
  CLICK: "Click",
  SERTIFICAT: "IHMA",
  UZUM_NASIYA: "Uzum nasiya",
  Payments: "To'lovlar",
  Rollback: "Qaytarildi",
  ExpenseType: "Chiqim turi",
  NameExpenseTypes: "Chiqim turi nomi",
  NewExpenseTypes: "Yangi chiqim turi",
  EditExpenseTypes: "Chiqim turi tahrirlash",
  DeleteExpenseTypes: "Chiqim turi o'chirish?",
  SearchExpenseTypes: "Chiqim turilarni qidirish",
  AmountOfAcceptedOrders: "Qabul qilingan buyurtmalar miqdori",
  TotalAmount: "To'lov miqdori",
  CancelAmount: "Qaytarilgan miqdori",
  ExpenseAmount: "Chiqim miqdori",
  Total: "Jami",
  Send: "Yuborish",
  Login: "Tizimga kirish",
  MY_PROFILE: 'Mening profilim',
  OldPassword: 'Eski parol',
  NewPassword: 'Yangi parol',
  EditPassword: 'Parolni o`zgartirish',
  ShortName: "Qisqa nomi",
  Loading: "Yuklanmoqda",
  AddFilial: "Filial qo'shish",
  SaveFilial: "Saqlash",
  RECEPTION: "Qabul",
  SearchPasient: "Mijozni qidirish",
  Indicator: "Kirim/Chiqim",
  EmployeeProductivity: "Xodimning samaradorligi",
  VisitCount: "Tashriflar soni",
  ClientCount: "Mijozlar soni",
  TopServices: "Ommabop xizmatlar",
  WorkHourse: "Ish soatlari",
  VisitHourse: "Tashrif soatlari",
  EmptyHourse: "Bo'sh soatlar",
  New: "Yangi",
  Ear_id: "O'ng/Chap",
  document_number: "Hujjat raqami",
  shop_id: "Do'kon ID",
  serial_number: "Seriya raqami",
  total_reverse_trans_amount: "Qaytarilgan summa",
  total_trans_amount: "Nomenklatur summasi",
  total_order_amount: "Buyurtma summasi",
  total_credit_amount: "Chiqim summasi",
  FullOrderList: "Buyurtmalar ro'yxati",
  TotalTransactSummary: "Umumiy hisobot",
  YearOfFilial: "Faoliyati boshlangan yil",
  UnitPrice: "Dona narx",
  NEACTIVE: "Faol emas",
  ACTIVE: "Faol",
  SpecializationType: "Mutaxassislik",
  NameSpecializationTypes: "Mutaxassislik nomi",
  NewSpecializationTypes: "Yangi mutaxassislik",
  EditSpecializationTypes: "Mutaxassislik tahrirlash",
  DeleteSpecializationTypes: "Mutaxassislik o'chirish?",
  SearchSpecializationTypes: "Mutaxassisliklarni qidirish",
  PaymentHistory: "To'lov tarixi",
  IsDeleteClientOrder: "Afsus to'lov qilinganligi sababli o'chirib bo'lmaydi!",
  DocumentNumber: "Shartnoma raqami",
  More: "Batafsil",
  Income: "Kirim",
  Rollback: "Qaytarilgan",
  Debt: "Qarzdorlik",
  Sold: "Sotilgan",
  Repair: "Tamir",
  Labaratory: "Labaratoriya",
  PHONE_NUMBER_DUBLICATE:"Ushbu raqam avval ro'yxatdan o'tgan, iltimos telefon raqam yoki berilgan ism familya bo'yicha qidiring! <br>",
  DescLab:"Labaratoriya tavsifi",
  Working:"Jarayonda",
  Acceptance:"Qabul",
  Ready:"Tayyor",
  IsDeleteClientOrderPOR: "Afsus matriallar qatorida mahsulotlar, buyurtmalar yoki tamir borligi sababli yozuvni o'chirib bo'lmaydi!",
  IsDeleteClientOrderSales: "Afsus sotuv bo'limida mahsulotlar, buyurtmalar yoki tamir borligi sababli yozuvni o'chirib bo'lmaydi!",
  NotDelete: "O'chirib bo'lmaydi!",
  SalesHistory:"Sotuvlar tarixi",
  SelectDate:"Sana tanlang",
  ProductsType:"Mahsulot turi",
  AllPrice:"Jami summa",
  District:"Tuman/Shahar",
  SearchSeria:"Seria qidirish",
  Search:"Qidiruv",
  Sum: "so'm",
  CurrencyRate: "Valyuta kurs",
  CurrencyHistory: "Kurs tarixi",
  date:"sana",
  AddServices: "Xizmatlarni qo'shish",
  HowDidYouHearAboutUs: "Xabardor bo'lganlik",
  ForgotPassword: "  Parolni unutdingizmi?",
  NewEmailPassword: "Ushbu emailga yangi parol jo'natiladi",
  Materilas: "Materiallar",
  ClientHistory: "Mijoz tarixi",
  ProductNumber: "Tovar raqami",
  SorryNoProduct: "Afsus bunday tovar topilmadi",
  Found: "topildi",
  NoOrder: "Buyurtma yo'q",
  AddOrder: "Buyurtma qo'shish",
  Right: "O'ng",
  Left: "Chap",
  OnsideColor: "Tashqi rang",
  InColor: "Ichki rang",
  Size: "O'lchami",
  UsedProducts: "Foydalanilangan mahsulotlar",
  ProductHistory: "Mahsulot tarixi",
  Too: "ga",
  Fromm: "dan",
  SuccessfullyCompleted: "Muvofiqiyatli yakunladimi",
  DoYouWantToReturnTheGoods: "Siz tovarni qaytarmoqchimisiz?",
  YouAddedThisSeries: "Bunday seriani qo'shgansiz",
  SeriaNumber: "Seria raqam",
  AvailableSerialNumbers: "Mavjud Seria raqamlar",
  AvailableQuantity: "Mavjud miqdor",
  FinishedProduct: "Tayyor mahsulot",
  FinishedProductConfirmation: "Tayyor mahsulotni tasdiqlash",
  NotRefundable: "Qaytarilishi mumkin emas",
  HearingAids: "Eshitish moslamalari",
  PersonalHearingAids: "Shaxsiy eshitish moslamalari",
  HearingAidParts: "Eshitish moslamalari uchun qismlar",
  OtherGoods: "Boshqa tovarlar",
  Location: "Joylashgan joyi",
  NotificationAmount: "Xabar berish miqdori",
  AvailableItems: "Tovari mavjud bo'lganlari",
  Transactions: "Tranzaksiyalar",
  NoProductToRepair: "Tamirlanadigan mahsulot yo'q",
  EnterOnlyLatinLetters: "Faqat lotin harflarini kiriting!",
  Remainder: "Qoldiq",
  TotalCalculatedAmount: "Jami hisoblangan miqdor",
  Conclusion:"Yakunlash",
  ThankYouLook:"Rahmat! Yana kutamiz.",
  ProductsAboutInfo: "Mahsulotlar haqida ma'lumot",
  ServicesAboutInfo: "Xizmatlar haqida ma'lumot",
  Incomes: "Kirimlar",
  AboutInfo: "haqida ma'lumot",
  ServiceWork : "Xizmat ko'rsatish",
  PaymentType : "To'lov turi",
  User: "Foydalanuvchi",
  IncorrectUsernameOrPassword :"Foydalanuvchi nomi yoki parol noto'g'ri",
  SendEmail:"emailga jo'natildi",
  PaidP: "Pullik",
  Series: "Seriali",
  WithoutSeries: "Seriasiz",
  NotPaid : "To'lanmagan",
  CustomerMap: "Mijoz xaritasi",
  AutomaticSalaryCalculation: "Maoshni avtomatik ravishda hisoblash",
  Salary: "Oylik",
  Retail: "Chakana",
  EstimatedSalary: "Hisoblangan maosh",
  Bonus:"Bonus",
  Salaries: "Maoshlar",
  YouHaveSignedOut: "Siz tizimdan chiqdingiz!",
  Users:"Foydalanuvchilar",
  ChangeLanguage:"Tilni o'zgartirish",
  Yes:"Ha",
  Not:"Yo'q",
  NewOrder:"Yangi buyurtma",
  EditOrder:"Buyurtmani tahrirlash",
  Width:"Eni",
  Height:"Bo'yi",
  PeriodSize:"Masofa"
};

export default locale;
